import type { createFlightSegmentModel } from '@elara/client-core/models/FlightSegmentModel';

/** The vertical departure → arrival timeline for a flight leg (time + airport at each end). */
export function FlightTimeline({ segment }: { segment: ReturnType<typeof createFlightSegmentModel> }) {
  const bulletSeparator = <div>∙</div>;

  return (
    <div className="grid grid-cols-[16px_auto] grid-rows-[auto_auto_auto] @xl:grid-cols-[24px_1fr] gap-y-2 gap-x-2 @xl:gap-x-4">
      {/* Vertical line with dots */}
      <div className="col-start-1 col-span-1 row-start-1 row-span-3 flex flex-col items-center py-0.5 @xl:py-1">
        <div className="w-4 h-4 rounded-full border border-input"></div>
        <div className="w-px flex-1 border-r border-input"></div>
        <div className="w-4 h-4 rounded-full border border-input"></div>
      </div>

      {/* Origin */}
      <div className="col-start-2 col-span-1 row-start-1 row-span-1 text-sm @xl:text-base flex items-baseline gap-1 overflow-hidden">
        <span className="whitespace-nowrap font-medium">{segment.formattedDepartureTime}</span>
        {bulletSeparator}
        <span className="truncate">
          {segment.origin.airport_name} ({segment.originCode})
        </span>
      </div>

      {/* Travel time */}
      <div className="col-start-2 col-span-1 row-start-2 row-span-1 text-sm my-3 text-muted-foreground">
        {segment.formattedDuration ? `${segment.formattedDuration} travel time` : ''}
      </div>

      {/* Destination */}
      <div className="col-start-2 col-span-1 row-start-3 row-span-1 text-sm @xl:text-base flex items-baseline gap-1 overflow-hidden">
        <span className="whitespace-nowrap font-medium">
          {segment.formattedArrivalTime}{' '}
          {segment.isOvernight && <sup className="text-xxs text-muted-foreground font-normal">+1</sup>}
        </span>
        {bulletSeparator}
        <span className="truncate">
          {segment.destination.airport_name} ({segment.destinationCode})
        </span>
      </div>
    </div>
  );
}
